module.exports = __webpack_public_path__ + "static/media/gqP68pSR2uM.255d1242.png";